import { render } from "./Offline.vue?vue&type=template&id=10be044a"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"

import "./Offline.vue?vue&type=style&index=0&id=10be044a&lang=css"

import exportComponent from "/home/ubuntu/estatus-pedido-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__